const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getCompanyId = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  return user.company_id || "";
};

const ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  SEND_MFA_OTP: `${API_BASE_URL}/auth/send-mfa-otp`,
  VERIFY_MFA: `${API_BASE_URL}/auth/verify-mfa`,
  FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
  UPLOAD_DOCUMENT: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/documents/upload`,
  UPLOAD_Multiple_DOCUMENT: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/documents/upload-multiple`,
  UPLOAD_Multiple_DOCUMENT_CHATBOT: (companyId, chatbotId) =>
    `${API_BASE_URL}/companies/${companyId}/documents/upload-multiple?chatbot_id=${chatbotId}`,
  GET_DOCUMENTS: (companyId, page = 1, limit = 10) =>
    `${API_BASE_URL}/companies/${companyId}/documents?page=${page}&limit=${limit}`,
  DELETE_DOCUMENT: (companyId, documentId) =>
    `${API_BASE_URL}/companies/${companyId}/documents/${documentId}`,
  UPDATE_DOCUMENT: (companyId, documentId, chatbotId = null) =>
    chatbotId
      ? `${API_BASE_URL}/companies/${companyId}/documents/${documentId}/update?chatbot_id=${chatbotId}`
      : `${API_BASE_URL}/companies/${companyId}/documents/${documentId}/update`,
  CLEAR_ALL_DOCUMENTS: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/documents`,
  BULK_DELETE_DOCUMENTS: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/documents/bulk-delete`,
  UPDATE_COMPANY_ADMIN: (companyId) =>
    `${API_BASE_URL}/_admin/companies/${companyId}`,
  CHAT: (companyId) => `${API_BASE_URL}/companies/${companyId}/chat`,
  START_CONVERSATION: (companyId, userId) =>
    `${API_BASE_URL}/companies/${companyId}/conversations?user_id=${userId}`,
  START_CHATBOT_CONVERSATION: (companyId, userId, chatbotId) =>
    `${API_BASE_URL}/companies/${companyId}/conversations?user_id=${userId}&chatbot_id=${chatbotId}`,
  CONTINUE_CONVERSATION: (companyId, conversationId, userId) =>
    `${API_BASE_URL}/companies/${companyId}/conversations/${conversationId}/messages?user_id=${userId}`,
  GET_CONVERSATION_List: (company_id, user_id) =>
    `${API_BASE_URL}/companies/${company_id}/conversations?user_id=${user_id}`,
  GET_CONVERSATIONS_BY_CHATBOT: (company_id, user_id, chatbot_id) =>
    `${API_BASE_URL}/companies/${company_id}/conversations?user_id=${user_id}&chatbot_id=${chatbot_id}`,
  GET_SPECIFIC_CONVERSATION: (companyId, conversationId, userId) =>
    `${API_BASE_URL}/companies/${companyId}/conversations/${conversationId}/messages?user_id=${userId}`,
  DELETE_CONVERSATION: (company_id, conversation_id, user_id) =>
    `${API_BASE_URL}/companies/${company_id}/conversations/${conversation_id}?user_id=${user_id}`,
  UPLOAD_DOCUMENT_GOOGLE_DRIVE: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/documents/download-from-google-drive`,
  UPLOAD_DOCUMENT_GOOGLE_DRIVE_CHATBOT: (company_id, chatbot_id) =>
    `${API_BASE_URL}/companies/${company_id}/documents/download-from-google-drive?chatbot_id=${chatbot_id}`,
  UPLOAD_DOCUMENT_ONEDRIVE: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/documents/download-from-onedrive`,
  UPLOAD_DOCUMENT_ONEDRIVE_CHATBOT: (company_id, chatbot_id) =>
    `${API_BASE_URL}/companies/${company_id}/documents/download-from-onedrive?chatbot_id=${chatbot_id}`,
  UPLOAD_DOCUMENT_SHAREPOINT: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/documents/download-from-sharepoint`,
  CHANGE_PASSWORD: (user_id) => `${API_BASE_URL}/users/${user_id}/password`,
  SEARCH_CONVERSATIONS: (company_id, user_id) =>
    `${API_BASE_URL}/companies/${company_id}/conversations/search?user_id=${user_id}`,
  UPDATE_CHATBOT_SETTINGS: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/chatbots/settings`,
  SAVE_CHATBOT_MESSAGE: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/chatbot-messages`,
  GET_CHATBOT_MESSAGE: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/chatbot-messages/get`,
  CREATE_CHATBOT: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/chatbots`,
  GET_CHATBOTS: (company_id, user_id) =>
    user_id
      ? `${API_BASE_URL}/companies/${company_id}/chatbots?user_id=${user_id}`
      : `${API_BASE_URL}/companies/${company_id}/chatbots`,
  DELETE_CHATBOT: (company_id, chatbot_id) =>
    `${API_BASE_URL}/companies/${company_id}/chatbots/${chatbot_id}`,
  UPDATE_CHATBOT: (company_id, chatbot_id) =>
    `${API_BASE_URL}/companies/${company_id}/chatbots/${chatbot_id}`,
  GET_CHATBOT_ACCESS: (company_id, chatbot_id) =>
    `${API_BASE_URL}/companies/${company_id}/chatbots/${chatbot_id}/access`,
  UPDATE_CHATBOT_ACCESS: (company_id, chatbot_id) =>
    `${API_BASE_URL}/companies/${company_id}/chatbots/${chatbot_id}/access`,
  GET_COMPANY_USERS: (company_id) =>
    `${API_BASE_URL}/_admin/users?company_id=${company_id}`,
  CREATE_PROMPT_TEMPLATE: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-templates`,
  GET_PROMPT_TEMPLATES: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-templates`,
  UPDATE_PROMPT_TEMPLATE: (company_id, template_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-templates/${template_id}`,
  DELETE_PROMPT_TEMPLATE: (company_id, template_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-templates/${template_id}`,
  // Prompt Library - Folders
  GET_PROMPT_FOLDERS: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-library/folders`,
  CREATE_PROMPT_FOLDER: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-library/folders`,
  UPDATE_PROMPT_FOLDER: (company_id, folder_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-library/folders/${folder_id}`,
  DELETE_PROMPT_FOLDER: (company_id, folder_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-library/folders/${folder_id}`,
  // Prompt Library - Prompts (inside folder)
  GET_FOLDER_PROMPTS: (company_id, folder_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-library/folders/${folder_id}/prompts`,
  CREATE_FOLDER_PROMPT: (company_id, folder_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-library/folders/${folder_id}/prompts`,
  UPDATE_FOLDER_PROMPT: (company_id, folder_id, prompt_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-library/folders/${folder_id}/prompts/${prompt_id}`,
  DELETE_FOLDER_PROMPT: (company_id, folder_id, prompt_id) =>
    `${API_BASE_URL}/companies/${company_id}/prompt-library/folders/${folder_id}/prompts/${prompt_id}`,
  // OAuth – Connect Drives (match Drive Flow Test page)
  GOOGLE_OAUTH_LOGIN: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/auth/google/login`,
  GOOGLE_OAUTH_EXCHANGE: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/auth/google/token`,
  ONEDRIVE_OAUTH_LOGIN: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/auth/onedrive/login`,
  SHAREPOINT_OAUTH_LOGIN: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/auth/sharepoint/login`,
  // SharePoint discovery (sites -> document libraries -> folders)
  GET_SHAREPOINT_SITES: (companyId, q = "") =>
    `${API_BASE_URL}/companies/${companyId}/sharepoint/sites${q ? `?q=${encodeURIComponent(q)}` : ""}`,
  GET_SHAREPOINT_LIBRARIES: (companyId, siteId) =>
    `${API_BASE_URL}/companies/${companyId}/sharepoint/libraries?site_id=${encodeURIComponent(siteId)}`,
  GET_SHAREPOINT_FOLDERS: (companyId, driveId, folderId = "root") =>
    `${API_BASE_URL}/companies/${companyId}/sharepoint/folders?drive_id=${encodeURIComponent(driveId)}&folder_id=${encodeURIComponent(folderId)}`,
  LIST_DRIVE_TOKENS: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/drive-tokens`,
  // Drive files/documents (backend uses stored token)
  GET_GOOGLE_DRIVE_FILES: (companyId, pageSize = 10) =>
    `${API_BASE_URL}/companies/${companyId}/drive/files?page_size=${pageSize}`,
  GET_GOOGLE_DRIVE_DOCUMENTS: (companyId, maxResults = 500, folderId = null) => {
    const url = `${API_BASE_URL}/companies/${companyId}/drive/documents?max_results=${maxResults}`;
    return folderId ? `${url}&folder_id=${folderId}` : url;
  },
  GET_ONEDRIVE_FILES: (companyId, pageSize = 10) =>
    `${API_BASE_URL}/companies/${companyId}/onedrive/files?page_size=${pageSize}`,
  GET_ONEDRIVE_DOCUMENTS: (companyId, maxResults = 500, folderId = null) => {
    const url = `${API_BASE_URL}/companies/${companyId}/onedrive/documents?max_results=${maxResults}`;
    return folderId ? `${url}&folder_id=${folderId}` : url;
  },
  // Ingestion folders – monitor & ingest
  GET_DRIVE_FOLDERS: (companyId, driveType, folderId = "root") =>
    `${API_BASE_URL}/companies/${companyId}/${driveType === "onedrive" ? "onedrive" : "drive"}/folders?folder_id=${folderId}`,
  INGESTION_FOLDERS: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/ingestion-folders`,
  INGESTION_FOLDER_RUN_NOW: (companyId, monitorId) =>
    `${API_BASE_URL}/companies/${companyId}/ingestion-folders/${monitorId}/run-now`,
  SAVE_GOOGLE_DRIVE_TOKEN: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/drive-tokens/google-drive`,
  SAVE_ONEDRIVE_TOKEN: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/drive-tokens/onedrive`,
  // Disconnect (DELETE) a company-scoped drive connection. Same URL as the
  // save/get endpoints; used to clear a stale/expired connection so a new one
  // can be made. Admin only (enforced by backend via X-User-Id header).
  DISCONNECT_GOOGLE_DRIVE_TOKEN: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/drive-tokens/google-drive`,
  DISCONNECT_ONEDRIVE_TOKEN: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/drive-tokens/onedrive`,
  DISCONNECT_SHAREPOINT_TOKEN: (company_id) =>
    `${API_BASE_URL}/companies/${company_id}/drive-tokens/sharepoint`,
  GET_ALLOWED_MODELS: (companyId) =>
    `${API_BASE_URL}/companies/${companyId}/allowed-models`,
};

export default ENDPOINTS;
